import { render, staticRenderFns } from "./AlphaGeneration.vue?vue&type=template&id=56c4b218&scoped=true&"
import script from "./AlphaGeneration.vue?vue&type=script&lang=js&"
export * from "./AlphaGeneration.vue?vue&type=script&lang=js&"
import style0 from "./AlphaGeneration.vue?vue&type=style&index=0&id=56c4b218&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c4b218",
  null
  
)

export default component.exports